module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10.906 5.453\"><path id=\"パス_2129\" data-name=\"パス 2129\" d=\"M1551.542,1227.407l5.453,5.453,5.453-5.453Z\" transform=\"translate(-1551.542 -1227.407)\" fill=\"#fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/select_box.svg
// module id = Cbz1
// module chunks = 1